export const ManualPreadviceTransactionsStyle = `
  .fkTuFL {
    .bg-amber {
      background-color: #ffbf00;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .bg-green {
      background-color: #dbffdb;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
`;
